import { CaretRight } from '@carbon/icons-react';
import * as React from 'react';

import { VoiceboxReasoningStep } from 'bones/components/molecules/Voicebox/hooks/useReasoningStepsFromMessage';
import { VoiceboxMarkdown } from 'bones/components/molecules/Voicebox/shared/VoiceboxMarkdown';
import { VoiceboxResponseMessage } from 'bones/constants/voicebox/message';
import { VoiceboxSettings } from 'bones/constants/voicebox/settings';
import { Icon } from 'bones/design-system/components/icons/Icon';

export interface VoiceboxReasoningStepsProps {
  message: VoiceboxResponseMessage;
  reasoningSteps: VoiceboxReasoningStep[];
  settings: VoiceboxSettings;
}

export const VoiceboxReasoningSteps: React.VFC<VoiceboxReasoningStepsProps> = ({
  message,
  reasoningSteps,
  settings,
}) => {
  return (
    <div className="vb-voicebox-reasoning-steps">
      {reasoningSteps.map(({ text }, idx) => (
        <span
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
          className="vb-voicebox-reasoning-step"
        >
          <Icon IconComponent={CaretRight} size="sm" />
          <VoiceboxMarkdown
            markdown={text}
            messageId={message.messageId}
            settings={settings}
          />
        </span>
      ))}
    </div>
  );
};
